import { OrchestratorErrorResponse } from 'types/api/orchestrator';
import {
  OrchProbeRequest,
  OrchProbeResponse,
  ProbeErrorResponse,
  ProbeResponse
} from 'types/api/probe';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchProbeOptions = {
  accessToken: string;
  otpCode: string;
};

export function fetchProbe({
  accessToken,
  otpCode
}: FetchProbeOptions): FetchResponse<ProbeResponse, ProbeErrorResponse> {
  return fetchReq({
    body: {
      grant_type: 'authorization_probe',
      probes_ref: [
        {
          data: {
            type: 'OTP',
            value: otpCode
          }
        }
      ]
    },
    headers: {
      Authorization: `Bearer ${accessToken}`
    },
    mark: 'complete_identity_validation_probe',
    method: 'POST',
    url: endpoints.token.probe
  });
}

/* START GENAI@GHCOPILOT */
type FetchProbeOrchOptions = {
  accessToken: string;
  apikey: string;
  idValidationSessionId: string;
  otpCode: string;
  isVdiDisabled?: boolean;
};

export function fetchOrchProbe({
  accessToken,
  apikey,
  idValidationSessionId,
  isVdiDisabled,
  otpCode
}: FetchProbeOrchOptions): FetchResponse<OrchProbeResponse, OrchestratorErrorResponse> {
  const body: OrchProbeRequest = {
    idValidationSessionId,
    srcClientId: apikey,
    validationData: otpCode
  };

  if (isVdiDisabled) {
    body.isVdiDisabled = isVdiDisabled;
  }

  return fetchReq({
    body,
    headers: {
      access_token: accessToken
    },
    mark: 'complete_identity_validation_orchestrator_probe',
    method: 'POST',
    url: endpoints.orchestrator.probe
  });
}
/* END GENAI@GHCOPILOT */
